export default __webpack_public_path__ + "static/media/logo.c91fd1ca.svg";